import React from 'react';

const AdvisorCard = ({ advisor, isSelected, onSelect }) => {
  return (
    <div 
      key={advisor.id} 
      className={`flex items-center p-3 border-b cursor-pointer hover:bg-gray-50 transition-colors ${isSelected ? 'bg-purple-50' : ''}`}
      onClick={() => onSelect(advisor)}
    >
      <div className="flex-shrink-0 w-12 h-12 rounded-full overflow-hidden mr-3">
        <img 
          src={advisor.image} 
          alt={advisor.name} 
          className="w-full h-full object-cover"
        />
      </div>
      <div>
        <h4 className="font-medium text-gray-800">{advisor.name}</h4>
        <p className="text-gray-500 text-sm">{advisor.experience} experience</p>
      </div>
    </div>
  );
};

export default AdvisorCard;